<template>
  <!-- Header -->
  <div
    v-if="firstTemplate"
    class="container-top mt-5"
    :class="{ 'container-medium': lgAndUp || xlAndUp }"
  >
    <div class="row mb-5">
      <div class="col-md-12 px-0 d-flex justify-content-between">
        <div>
          <h2 class="form-title">New Donation Form</h2>
          <BackRoute />
        </div>
        <div class="active-toggle" v-if="!loadingEdit">
          <span class="active-label">Active</span>
          <el-switch v-model="isActive" />
        </div>
        <div class="active-toggle" v-else-if="!routeParams">
          <span class="active-label">Active</span>
          <el-switch v-model="isActive" />
        </div>
      </div>
    </div>

    <!-- Form Fields -->
    <div class="row justify-content-center">
      <div
        class="col-md-12 py-4 d-flex justify-content- border-radius-17"
        style="background-color: rgba(235, 237, 255, 0.3)"
      >
        <div class="col-md-10 mt-4 mb-5">
          <el-form label-position="top" :model="newContribution">
            <!-- Name Field -->
            <div class="row">
              <div class="col-md-4 text-left text-md-right">
                <label class="form-label">Name</label>
              </div>
              <div class="col-md-7">
                <el-input
                  type="text"
                  v-model="newContribution.name"
                  placeholder="Name of donation"
                  class="custom-input"
                />
              </div>
              <div class="col-md-1"></div>
            </div>
            <div
              class="row mt-4"
              v-for="(contribution, index) in newContribution.payment"
              :key="contribution.id"
            >
              <div class="col-md-4 text-left text-md-right">
                <label class="form-label">Contribution Item</label>
              </div>
              <div class="col-md-8">
                <div class="mb-3">
                  <div class="row">
                    <div class="col-md-10 pr-0">
                      <el-dropdown trigger="click" class="w-100">
                        <span class="el-dropdown-link w-100">
                          <div
                            class="d-flex justify-content-between border-contri w-100"
                            size="large"
                          >
                            <span class="text-secondary">{{
                              contribution && contribution.financialContribution
                                ? contribution.financialContribution.name
                                : contribution.name
                                ? contribution.name
                                : "Select"
                            }}</span>
                            <div>
                              <el-icon class="el-icon--right">
                                <arrow-down />
                              </el-icon>
                            </div>
                          </div>
                        </span>
                        <template #dropdown>
                          <el-dropdown-menu>
                            <el-dropdown-item
                              v-for="(itm, indx) in contributionItems"
                              :key="indx"
                              @click="selectContribution(itm, index)"
                              >{{ itm.name }}
                            </el-dropdown-item>
                            <el-dropdown-item @click="openContriModal"
                              ><a
                                class="font-weight-bold small-text d-flex justify-content-center py-2 text-decoration-none primary-text"
                                style="color: #136acd"
                              >
                                <el-icon size="large">
                                  <CirclePlus />
                                </el-icon>
                                Create new contribution item
                              </a></el-dropdown-item
                            >
                          </el-dropdown-menu>
                        </template>
                      </el-dropdown>
                    </div>
                    <div
                      class="col-1 align-self-center"
                      v-if="newContribution.payment.length > 1"
                    >
                      <el-icon
                        :size="18"
                        @click="showConfirmModal(contribution.id, index)"
                        :disabled="newContribution.payment.length === 1"
                      >
                        <Delete />
                      </el-icon>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-md-4"></div>
              <div class="col-md-7">
                <el-button
                  color="#268CFF"
                  class="add-btn"
                  @click="addContribution"
                >
                  +Add
                </el-button>
              </div>
              <div class="col-md-1"></div>
            </div>
            <div class="row">
              <div class="col-md-4"></div>
              <div class="col-md-7">
                <!-- Payment Gateway Selection -->
                <div class="row mt-5">
                  <div class="col-12">
                    <div class="form-group">
                      <label class="form-label"
                        >Select payment gateway or channel</label
                      >
                      <el-dropdown class="w-100" trigger="click">
                        <el-input
                          class="w-100"
                          placeholder="Select payment gateway or channel"
                          v-model="selectedGatewayName"
                          readonly
                        >
                          <!-- Append slot for dropdown icon -->
                          <template #suffix>
                            <el-icon>
                              <ArrowDown />
                            </el-icon>
                          </template>
                        </el-input>
                        <template #dropdown>
                          <el-dropdown-menu class="menu-height">
                            <el-dropdown-item
                              v-for="(gateway, index) in gateways"
                              :key="index"
                              @click="selectGateway(gateway)"
                            >
                              {{ gateway.displayName }} -
                              {{
                                gateway.config.bankName
                                  ? gateway.config.bankName
                                  : ""
                              }}
                              -
                              {{
                                gateway.config.bankAccountNumber
                                  ? gateway.config.bankAccountNumber
                                  : ""
                              }}
                              -
                              {{
                                gateway.config.accountName
                                  ? gateway.config.accountName
                                  : ""
                              }}
                            </el-dropdown-item>

                            <el-dropdown-item
                              class="d-flex justify-content-center cursor-pointer text-primary font-weight-700"
                              @click="addNewGateway"
                              divided
                            >
                              <el-icon>
                                <CirclePlus />
                              </el-icon>
                              Add new payment gateway
                            </el-dropdown-item>
                          </el-dropdown-menu>
                        </template>
                      </el-dropdown>
                      <div
                        @click="addNewGateway"
                        class="mt-2 d-flex justify-content-end text-dak fw-300 s-13 cursor-pointer"
                      >
                        <u> + Add new payment gateway & bank</u>
                      </div>
                      <!-- Selected List -->
                      <div v-if="selectedGateways.length" class="mt-3">
                        <div
                          v-for="(gateway, index) in selectedGateways"
                          :key="index"
                          class="d-flex justify-content-between align-items-center py-2 border-bottom"
                        >
                          <span class="s-13">
                            {{ gateway.displayName }} -
                            {{
                              gateway.config.bankName
                                ? gateway.config.bankName
                                : ""
                            }}
                            -
                            {{
                              gateway.config.bankAccountNumber
                                ? gateway.config.bankAccountNumber
                                : ""
                            }}
                            -
                            {{
                              gateway.config.accountName
                                ? gateway.config.accountName
                                : ""
                            }}
                          </span>
                          <el-icon
                            class="cursor-pointer text-danger"
                            @click="confirmDelete(gateway)"
                          >
                            <Delete />
                          </el-icon>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Save Button -->
                <div class="row mt-4">
                  <div class="col-12">
                    <div class="form-actions">
                      <el-button
                        class="button border-0 py-4 w-100 text-white"
                        round
                        :loading="loadingSave"
                        :class="{
                          'disabled-bg': disabled,
                          'primary-bg': !disabled,
                        }"
                        @click.prevent="saveAndContinue"
                        style="margin-left: 2px"
                      >
                        Save and Continue
                      </el-button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-1"></div>
            </div>
          </el-form>
        </div>
      </div>
    </div>
  </div>

  <!-- ChurchPlus Payment Modal -->
  <el-dialog
    v-model="showChurchPayment"
    title=""
    :width="mdAndUp || lgAndUp || xlAndUp ? `40%` : `90%`"
    :show-close="true"
    class="border-radius-20"
    @close="closeSecondModal"
  >
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12 text-center text-dak font-weight-600 s-20">
          ChurchPlus Payment Details
        </div>
        <div class="col-md-12 mt-2 px-0"><hr class="w-100" /></div>
      </div>

      <!-- 🔹 Payment Form Selector -->
      <div class="row mt-3 px-3">
        <div class="col-12 mb-3">
          <label class="form-label">Select Payment Gateway Category </label>
          <el-select
            v-model="selectedPaymentForm"
            placeholder="Select payment option"
            class="w-100"
            @change="getFinancialGateway"
          >
            <el-option
              v-for="form in paymentForms"
              :key="form.id"
              :label="form.label"
              :value="form"
            />
          </el-select>
          <span class="font-italic s-12 fw-500">{{
            selectedPaymentForm?.description
          }}</span>
        </div>
      </div>

      <!-- Form Fields -->
      <div class="row px-3" v-if="selectedPaymentForm?.value === 'bank'">
        <div class="col-md-12">
          <el-form label-position="top">
            <!-- Choose Bank -->
            <div class="row mt-2">
              <div class="col-12">
                <label class="form-label">Select Gateway Payment </label>
                <el-select
                  v-model="selectGatewayPaymentID"
                  placeholder="Select payment gateway"
                  class="w-100"
                  @change="setSelectedGatewayPayment"
                >
                  <el-option
                    v-for="item in gateWayPayments"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
              </div>
            </div>
            <!-- Choose Bank -->
            <div class="row mt-3">
              <div class="col-12 mb-3">
                <label class="form-label">Choose Bank</label>
                <el-select
                  v-model="selectedBankID"
                  filterable
                  placeholder="Choose Bank"
                  class="w-100"
                  @change="setSelectedBank"
                >
                  <el-option
                    v-for="(bank, index) in filteredBanks"
                    :key="index"
                    :label="bank.name"
                    :value="bank.id"
                  />
                </el-select>
              </div>
            </div>

            <!-- Account Number -->
            <div class="row">
              <div class="col-12 mb-3">
                <label class="form-label">Account Number</label>
                <el-input
                  type="text"
                  v-model="accountNumber"
                  placeholder="Account number"
                  class="w-100"
                  @blur="resolveCustomerDetail"
                />
                <span v-if="loading">
                  <el-icon :size="20" class="is-loading"> <Loading /> </el-icon
                ></span>
              </div>
            </div>

            <!-- Account Name -->
            <div class="row">
              <div class="col-12 mb-3">
                <label class="form-label">Account Name</label>
                <el-input
                  type="text"
                  v-model="accountName"
                  placeholder="Account name"
                  class="w-100 account-name-input"
                  disabled
                />
                <small class="helper-text"
                  >This will automatically come up</small
                >
              </div>
            </div>

            <!-- Payment Gateways -->
            <!-- <div class="row"> -->
            <!-- <div class="col-md-4 col-12 mb-3">
                <div class="col-md-12">
                  <el-radio v-model="paystackChecked" class="gateway-checkbox">
                    <div class="gateway-info">
                      <img
                        src="../../assets/4PaystackLogo.png"
                        alt="Paystack"
                        class="gateway-logo w-100"
                      />
                  
                    </div>
                  </el-radio>
                </div>
              </div> -->
            <!-- <div class="col-md-4 col-12 mb-3">
                <div class="col-md-12">
                  <el-radio
                    v-model="flutterwaveChecked"
                    class="gateway-checkbox"
                  >
                    <div class="gateway-info">
                      <img
                        src="../../assets/Full-Flutterwave.png"
                        alt="Flutterwave"
                        class="gateway-logo w-100"
                      />
                     
                    </div>
                  </el-radio>
                </div>
              </div> -->
            <!-- <div class="col-md-4 col-12 mb-3">
                <div class="col-md-12">
                  <el-radio v-model="alaPayChecked" class="gateway-checkbox">
                    <div class="gateway-info">
                      <img
                        src="../../assets/alat_logo.png"
                        alt="ALA PAY"
                        class="gateway-logo w-100"
                      />
                
                    </div>
                  </el-radio>
                </div>
              </div> -->
            <!-- </div> -->
          </el-form>

          <div class="row">
            <div class="col-12">
              <div class="dialog-footer">
                <el-button
                  round
                  :color="primarycolor"
                  class="w-100 py-4 text-white"
                  @click="saveGateway"
                >
                  Save
                </el-button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Connect a Payment Gateway -->
      <div class="row px-3" v-if="selectedPaymentForm?.value === 'connect'">
        <div class="col-md-12">
          <div class="row mt-2">
            <div class="col-12">
              <div class="form-group">
                <label class="form-label">Select Gateway Payment </label>
                <el-select
                  v-model="selectGatewayPaymentID"
                  placeholder="Select payment gateway"
                  class="w-100"
                  @change="setSelectedGatewayPayment"
                >
                  <el-option
                    v-for="item in gateWayPayments"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 mb-3">
              <label class="form-label">External Account Ref</label>
              <el-input
                type="text"
                v-model="connectForm.externalAccountRef"
                placeholder="Enter external account reference"
                class="w-100"
              />
            </div>
          </div>

          <!-- Access Token -->
          <div class="row">
            <div class="col-12 mb-3">
              <label class="form-label">Access Token</label>
              <el-input
                type="text"
                v-model="connectForm.accessTokenEncrypted"
                placeholder="Enter encrypted access token"
                class="w-100"
              />
            </div>
          </div>

          <!-- Refresh Token -->
          <div class="row">
            <div class="col-12 mb-3">
              <label class="form-label">Refresh Token</label>
              <el-input
                type="text"
                v-model="connectForm.refreshTokenEncrypted"
                placeholder="Enter encrypted refresh token"
                class="w-100"
              />
            </div>
          </div>

          <!-- Connected At -->
          <div class="row">
            <div class="col-12 mb-3">
              <label class="form-label">Connected At</label>
              <el-date-picker
                v-model="connectForm.connectedAt"
                type="datetime"
                placeholder="Select connected date"
                class="w-100"
                size="large"
              />
            </div>
          </div>
          <!-- <div class="row">
            <div class="col-12">
              <div class="connect-section">
                <h3 class="section-title">Connect a Payment Gateway</h3>

                <div class="gateway-list">
          
                  <div class="row">
                    <div class="col-12">
                      <div class="gateway-connect-item">
                        <div class="row w-100">
                          <div class="col-md-8">
                            <div class="gateway-info">
                              <img
                                src="../../assets/stripe.png"
                                alt="Stripe"
                                style="width: 4rem"
                                class="gateway-icon"
                              />
                          
                            </div>
                          </div>
                          <div class="col-md-4 text-right">
                            <el-button
                              link
                              class="connect-btn"
                              @click="connectGateway('stripe')"
                            >
                              Connect
                            </el-button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

      
                  <div class="row">
                    <div class="col-12">
                      <div class="gateway-connect-item">
                        <div class="row align-items-center w-100">
                          <div class="col-8">
                            <div class="gateway-info">
                              <img
                                src="../../assets/Full-Flutterwave.png"
                                alt="Flutterwave"
                                class="gateway-icon"
                                style="width: 5rem"
                              />
                             
                            </div>
                          </div>
                          <div class="col-4 text-right">
                            <el-button
                              link
                              class="connect-btn"
                              @click="connectGateway('flutterwave')"
                            >
                              Connect
                            </el-button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

            
                  <div class="row">
                    <div class="col-12">
                      <div class="gateway-connect-item">
                        <div class="row align-items-center w-100">
                          <div class="col-8">
                            <div class="gateway-info">
                              <img
                                src="../../assets/4PaystackLogo.png"
                                alt="Paystack"
                                class="gateway-icon"
                                style="width: 5rem"
                              />
                        
                            </div>
                          </div>
                          <div class="col-4 text-right">
                            <el-button
                              link
                              class="connect-btn"
                              @click="connectGateway('paystack')"
                            >
                              Connect
                            </el-button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> -->

          <div class="row">
            <div class="col-12 mt-3">
              <div class="dialog-footer">
                <el-button
                  round
                  :color="primarycolor"
                  class="text-white py-4 w-100"
                  @click="saveGateway"
                >
                  Save
                </el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Business Public & Private Key -->
      <div
        class="row px-3"
        v-if="selectedPaymentForm?.value === 'pub-priv-key'"
      >
        <div class="col-md-12">
          <el-form label-position="top">
            <!-- Choose Bank -->
            <div class="row mt-2">
              <div class="col-12">
                <div class="form-group">
                  <label class="form-label">Select Gateway Payment </label>
                  <el-select
                    v-model="selectGatewayPaymentID"
                    placeholder="Select payment gateway"
                    class="w-100"
                    @change="setSelectedGatewayPayment"
                  >
                    <el-option
                      v-for="item in gateWayPayments"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    />
                  </el-select>
                </div>
              </div>
            </div>

            <!-- Public key -->
            <div class="row">
              <div class="col-12 mb-3">
                <label class="form-label">Public Key</label>
                <el-input
                  type="text"
                  v-model="keysForm.publicKeyEncrypted"
                  placeholder="000000"
                  class="w-100"
                />
              </div>
            </div>

            <!-- Privite key -->
            <div class="row">
              <div class="col-12 mb-3">
                <label class="form-label">Secret Key</label>
                <el-input
                  type="text"
                  v-model="keysForm.secretKeyEncrypted"
                  placeholder="000000"
                  class="w-100"
                />
              </div>
            </div>
            <!-- Webhook Key -->
            <div class="row">
              <div class="col-12 mb-3">
                <label class="form-label">Webhook Key</label>
                <el-input
                  v-model="keysForm.webhookKeyEncrypted"
                  type="text"
                  placeholder="000000"
                  style="background-color: #e9feff"
                  class="w-100"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-12 text-dak s-15 text-center">
                Kindly update your webhook url with
              </div>
              <div
                class="col-12 font-italic text-center font-weight-bold s-15 text-dak"
              >
                http://churchplus.co/webhooks/name
              </div>
            </div>
          </el-form>
          <div class="row">
            <div class="col-12 mt-3">
              <div class="dialog-footer">
                <el-button
                  round
                  :color="primarycolor"
                  class="w-100 py-4 text-white"
                  @click="saveGateway"
                >
                  Save
                </el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>

  <!-- Connect Payment Gateway Modal -->
  <el-dialog
    v-model="showConnectGateway"
    title=""
    :width="mdAndUp || lgAndUp || xlAndUp ? `50%` : `90%`"
    :show-close="true"
    class="border-radius-20"
    @close="closeThirdModal"
  >
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12 text-center text-dak font-weight-600 s-20">
          Choose or connect a Payment Gateway
        </div>
        <div class="col-md-12 mt-2 px-0"><hr class="w-100" /></div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="connect-section">
            <h3 class="section-title">Connect a Payment Gateway</h3>

            <div class="gateway-list">
              <div class="row">
                <div class="col-12">
                  <div class="gateway-connect-item">
                    <div class="row w-100">
                      <div class="col-md-8">
                        <div class="gateway-info">
                          <img
                            src="../../assets/stripe.png"
                            alt="Stripe"
                            class="gateway-icon"
                          />
                        </div>
                      </div>
                      <div class="col-md-4 text-right">
                        <el-button
                          link
                          class="connect-btn"
                          @click="connectGateway('stripe')"
                        >
                          Connect
                        </el-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-12">
                  <div class="gateway-connect-item">
                    <div class="row align-items-center w-100">
                      <div class="col-8">
                        <div class="gateway-info">
                          <img
                            src="../../assets/Full-Flutterwave.png"
                            alt="Flutterwave"
                            class="gateway-icon"
                            style="width: 5rem !important"
                          />
                        </div>
                      </div>
                      <div class="col-4 text-right">
                        <el-button
                          link
                          class="connect-btn"
                          @click="connectGateway('flutterwave')"
                        >
                          Connect
                        </el-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Paystack -->
              <div class="row">
                <div class="col-12">
                  <div class="gateway-connect-item">
                    <div class="row align-items-center w-100">
                      <div class="col-8">
                        <div class="gateway-info">
                          <img
                            src="../../assets/4PaystackLogo.png"
                            alt="Paystack"
                            class="gateway-icon"
                          />
                        </div>
                      </div>
                      <div class="col-4 text-right">
                        <el-button
                          link
                          class="connect-btn"
                          @click="connectGateway('paystack')"
                        >
                          Connect
                        </el-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <template #footer>
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <div class="dialog-footer">
              <el-button
                round
                :color="primarycolor"
                class="text-white py-4 w-100"
                @click="saveGateway"
              >
                Save
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </template>
  </el-dialog>
  <el-dialog
    v-model="showConnectGatewayDialog"
    title=""
    :width="mdAndUp || lgAndUp || xlAndUp ? `50%` : `90%`"
    :show-close="true"
    class="border-radius-20"
  >
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12 text-center text-dak font-weight-600 s-20">
          Connect
        </div>
        <div class="col-md-12 mt-2 px-0"><hr class="w-100" /></div>
      </div>
      <el-form label-position="top" class="px-3">
        <!-- Choose Bank -->
        <div class="row mt-2">
          <div class="col-12">
            <div class="form-group">
              <label class="form-label">Ministry / Business name</label>
              <el-input
                type="text"
                v-model="ministryName"
                placeholder="Name of ministry or business"
                class="w-100"
              />
            </div>
          </div>
        </div>

        <!-- Privite key -->
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label class="form-label">Currency</label>
              <el-select
                v-model="selectedCurrencyID"
                placeholder="Select"
                class="w-100"
                @change="setSelectedCurrency"
                filterable
              >
                <el-option
                  v-for="item in currencyList"
                  :label="item.displayName"
                  :value="item.id"
                  :key="item.id"
                />
              </el-select>
            </div>
          </div>
        </div>
        <!-- Webhook Key -->
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label class="form-label">Email</label>
              <el-input
                type="email"
                v-model="email"
                placeholder="Email"
                style="background-color: #e9feff !important"
                class="w-100"
              />
            </div>
          </div>
        </div>
      </el-form>
    </div>

    <template #footer>
      <div class="container-fluid px-3">
        <div class="row">
          <div class="col-12">
            <div class="dialog-footer">
              <el-button
                round
                :color="primarycolor"
                class="w-100 py-4 text-white"
                @click="continueToPayment"
              >
                Integrate
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </template>
  </el-dialog>
  <el-dialog
    v-model="showGreatWorkModal"
    title=""
    :width="mdAndUp || lgAndUp || xlAndUp ? `50%` : `90%`"
    :show-close="true"
    class="border-radius-20"
  >
    <div class="container-fluid">
      <!-- Choose Bank -->
      <div class="row mt-2">
        <div class="col-md-12 d-flex justify-content-center">
          <div class="col-md-6 col-12">
            <img
              class="w-100"
              src="../../assets/mobileonboarding/sub-successful.gif"
              alt=""
            />
          </div>
        </div>
        <div class="col-md-12 d-flex justify-content-center">
          <div
            class="col-md-6 col-12 text-center text-dak font-weight-600 s-16"
          >
            Great work
          </div>
        </div>
        <div class="col-md-12 d-flex justify-content-center mt-2">
          <div class="col-12 text-center s-16 text-dak">
            Click this <a href="">Link</a> to complete account <br />
            linking or check your email
          </div>
        </div>
        <div class="col-md-12 mt-3 d-flex justify-content-center mt-2">
          <div class="col-md-6 col-12 text-center s-16 text-dak">
            <el-button
              round
              :color="primarycolor"
              class="w-100 py-4 text-white"
              @click="closeModal"
            >
              Close
            </el-button>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>

  <!-- ChurchPlus Payment with keys Modal -->
  <el-dialog
    v-model="showGatewayWithKey"
    title=""
    :width="mdAndUp || lgAndUp || xlAndUp ? `50%` : `90%`"
    :show-close="true"
    class="border-radius-20"
    @close="closeSecondModal"
  >
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12 text-center text-dak font-weight-600 s-20">
          Public & Private Keys
        </div>
        <div class="col-md-12 mt-2 px-0"><hr class="w-100" /></div>
      </div>
      <el-form label-position="top" class="px-3">
        <!-- Choose Bank -->
        <div class="row mt-2">
          <div class="col-12">
            <div class="form-group">
              <label class="form-label">Select Gateway</label>
              <el-select
                v-model="selectedGateway"
                placeholder=""
                class="w-100 connected-gateway-select"
              >
                <el-option
                  v-for="(gateway, index) in gateways"
                  :key="index"
                  :label="gateway.displayName"
                  :value="gateway.id"
                />
              </el-select>
            </div>
          </div>
        </div>

        <!-- Public key -->
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label class="form-label">Public Key</label>
              <el-input
                type="text"
                v-model="publicKey"
                placeholder="000000"
                class="w-100"
              />
            </div>
          </div>
        </div>

        <!-- Privite key -->
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label class="form-label">Secret Key</label>
              <el-input
                type="text"
                v-model="secretKey"
                placeholder="000000"
                class="w-100"
              />
            </div>
          </div>
        </div>
        <!-- Webhook Key -->
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label class="form-label">Webhook Key</label>
              <el-input
                v-model="webhookKey"
                type="text"
                placeholder="000000"
                style="background-color: #e9feff"
                class="w-100"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 text-dak s-15 text-center">
            Kindly update your webhook url with
          </div>
          <div
            class="col-12 font-italic text-center font-weight-bold s-15 text-dak"
          >
            http://churchplus.co/webhooks/name
          </div>
        </div>
      </el-form>
    </div>

    <template #footer>
      <div class="container-fluid px-3">
        <div class="row">
          <div class="col-12">
            <div class="dialog-footer">
              <el-button
                round
                :color="primarycolor"
                class="w-100 py-4 text-white"
                @click="continueToPayment"
              >
                Continue to Pay
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </template>
  </el-dialog>
  <el-dialog
    v-model="displayResponsive"
    title=""
    :width="mdAndUp || lgAndUp || xlAndUp ? `50%` : `90%`"
  >
    <div class="row">
      <div class="col-md-12">
        <p>
          You have no income account to create a offering item, go to Chart of
          Account and click 'Update Account' to update your accounts.
        </p>
      </div>
    </div>
    <template #footer>
      <!-- <Button label="No" icon="pi pi-times" @click="closeResponsive" class="p-button-text"/> -->
      <el-button
        round
        class="w-100 text-white primary-bg"
        label="Go to Chart Of Accounts"
        @click="closeResponsive"
        autofocus
        >Go to Chart Of Accounts<el-icon>
          <Check />
        </el-icon>
      </el-button>
    </template>
  </el-dialog>
  <el-dialog
    v-model="displayContributionItem"
    class="border-radius-20"
    title=""
    :width="mdAndUp || lgAndUp || xlAndUp ? `50%` : `90%`"
  >
    <div class="row">
      <div class="col-md-12 text-center text-dak font-weight-600 s-20">
        Add Contribution
      </div>
      <div class="col-md-12">
        <ContributionItems
          @item-name="newConItems"
          @show-update-modal="toggleDisplayModal"
          @close-dialog="closeContriDialog"
        />
      </div>
    </div>
  </el-dialog>

  <!-- Optional Notification -->
  <div class="container-fluid" v-if="displayNotification">
    <div class="row">
      <div class="col-12">
        <el-alert
          title="You must connect a payment gateway before proceeding"
          type="warning"
          show-icon
          class="mt-4"
          @click="routeToIntegrations"
          :closable="false"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, inject, reactive, watch } from "vue";
import finish from "../../services/progressbar/progress";
import ContributionItems from "@/components/firsttimer/contributionItemModal";
import { useRoute, useRouter } from "vue-router";
import deviceBreakpoint from "../../mixins/deviceBreakpoint";
import { ElMessageBox, ElNotification } from "element-plus";
import axios from "@/gateway/backendapi";
import transactionals from "../accounting/chartOfAccount/utilities/transactionals";
import BackRoute from "../../components/backroute/BackRoute.vue";
import axio from "axios";
import { useStore } from "vuex";

// Global states and store
const store = useStore();
const route = useRoute();
const router = useRouter();
const loadingSave = ref(false);
const loadingEdit = ref(false);
const showGreatWorkModal = ref(false);
const primarycolor = inject("primarycolor");
const selectedCurrencyID = ref(null);
const emit = defineEmits(["form-details", "payment-form"]);

// Data
const newContribution = ref({ name: "", payment: [{}] });
const { lgAndUp, xlAndUp, mdAndUp } = deviceBreakpoint();
const routeParams = ref(route.params.editNewPayment);
const displayContributionItem = ref(false);
const contributionItems = ref([]);
const selectedBank = ref({});
const accountNumber = ref("");
const nigerianBanks = ref([]);
const accountName = ref("");
const paymentGateWays = ref([]);
const gateWayPayments = ref([]);
const selectedBanks = ref([]);
const displayResponsive = ref(false);
const displayNotification = ref(false);
const firstTemplate = ref(true);
const loading = ref(false);
const gatewayNotification = ref(false);
const showChurchPayment = ref(false);
const showConnectGateway = ref(false);
const showGatewayWithKey = ref(false);
const showConnectGatewayDialog = ref(false);
const selectedBankID = ref(null);
const isActive = ref(true);
const publicKey = ref("");
const email = ref("");
const ministryName = ref("");
const secretKey = ref("");
const webhookKey = ref("");
const bankSearchText = ref("");
const selectedGateway = ref("");
const selectedDefaultPayment = ref("");
const selectedGatewayConnect = ref("");
const selectedGatewayWithKey = ref("");
const removeContributionIDs = ref([]);
const removePaymentGatewayIDs = ref([]);

const currencyList = ref([]);
const selectedCurrency = ref({});

const gateways = ref([]);
const selectedGatewayName = ref("");
const selectGatewayPaymentID = ref(null);
const selectedGateways = ref([]);
const selectedPaymentGateway = ref({});

// Gateway checkboxes
const disabled = ref(false);
// === State ===
const selectedPaymentForm = ref(null); // "bank" | "connect" | "pub-priv-key"

// --- Connect form fields ---
const connectForm = reactive({
  externalAccountRef: "",
  accessTokenEncrypted: "",
  refreshTokenEncrypted: "",
  connectedAt: new Date().toISOString(),
});

// --- Public/Private Keys form fields ---
const keysForm = reactive({
  publicKeyEncrypted: "",
  secretKeyEncrypted: "",
  webhookSecretEncrypted: "",
});

const getFinancialGateway = async () => {
  if (!selectedPaymentForm.value?.value) return;

  try {
    const { data } = await axios.get(
      `api/Payment/GetPaymentGatewaysByIntegrationType`,
      {
        params: { integrationType: selectedPaymentForm.value?.id }, // pass id as query string
      }
    );
    gateWayPayments.value = data;
    selectGatewayPaymentID.value = null;
  } catch (err) {
    console.log("Error fetching payment gateways", err);
  }
};
// getFinancialGateway();
watch(selectedPaymentForm, (newVal) => {
  if (newVal) {
    getFinancialGateway();
  }
});

const setSelectedGatewayPayment = () => {
  selectedPaymentGateway.value = gateWayPayments.value.find(
    (g) => g.id === selectGatewayPaymentID.value
  );
  console.log(selectedPaymentGateway.value, "Selected Gateway Payment");
};

// === Save handler ===
async function saveGateway() {
  let config = {};

  if (selectedPaymentForm.value?.value === "bank") {
    config = {
      // subAccountId: selectedBankID.value || "",
      bankName: selectedBank.value.name || "",
      bankCode: selectedBank.value.code || "",
      bankAccountNumber: accountNumber.value,
      accountName: accountName.value,
    };
  }

  if (selectedPaymentForm.value?.value === "connect") {
    config = {
      ...connectForm,
    };
  }

  if (selectedPaymentForm.value?.value === "pub-priv-key") {
    config = {
      ...keysForm,
    };
  }

  const payload = {
    // id: currentGatewayId.value,
    // tenantID: tenantId.value,
    paymentGatewayID: selectedPaymentGateway.value.id,
    displayName: selectedPaymentGateway.value.name,
    config,
    createdAt: new Date().toISOString(),
  };

  try {
    const res = await axios.post("/api/Payment/churchpaymentgateway", payload);
    if (res.data) {
      // Wait for gateways to refresh
      await fetchGateways();

      // Select the newest gateway (last one)
      if (gateways.value && gateways.value.length > 0) {
        const newest = gateways.value[gateways.value.length - 1];
        selectGateway(newest);
      }
    }
    ElNotification.success("Gateway saved successfully");
    showChurchPayment.value = false;
  } catch (err) {
    ElNotification.error("Failed to save gateway");
    console.log(err);
  }
}

// Add this new reactive data
const contributionSelections = ref([{ selectedItem: "", id: Date.now() }]);

const getCurrenciesFromCountries = async () => {
  const response = await transactionals.getCurrencies();
  currencyList.value = response;
};
getCurrenciesFromCountries();
const setSelectedCurrency = () => {
  selectedCurrency.value = currencyList.value.find(
    (i) => i.id == selectedCurrencyID.value
  );
};
const closeModal = () => {
  showGreatWorkModal.value = false;
};

// Fetch church payment gateways
// const fetchGatewayOptions = async () => {
//   try {
//     const res = await axios.get("/api/Payment/churchpaymentgateway/options");
//     console.log(res.data, "Fetched gateways options");
//   } catch (error) {
//     console.error("Error fetching gateways:", error);
//   }
// };
// fetchGatewayOptions();

// Fetch church payment gateways
const fetchGateways = async () => {
  try {
    const res = await axios.get("/api/Payment/churchpaymentgateway");
    gateways.value = res.data || [];
  } catch (error) {
    console.error("Error fetching gateways:", error);
  }
};
fetchGateways();

const paymentForms = ref([
  {
    id: 0,
    label: "ChurchPlus Gateway – Quick Start (Recommended)",
    value: "bank",
    description:
      "No setup required, fastest to start. ChurchPlus handles settlement, payouts, and compliance.",
  },
  {
    id: 1,
    label: "Own Gateway – Easy Setup (Linked Account / Connect)",
    value: "connect",
    description:
      "The church connects their Stripe, Paystack, or other supported platforms via OAuth or dashboard link.",
  },
  {
    id: 2,
    label: "Custom Gateway – Use API Keys",
    value: "pub-priv-key",
    description:
      "The most advanced option where the church pastes API keys. Best for tech-savvy teams or larger churches.",
  },
]);

const selectGateway = (gateway) => {
  // prevent duplicates
  if (!selectedGateways.value.find((g) => g.id === gateway.id)) {
    selectedGateways.value.push(gateway);
    selectedGatewayName.value =
      gateway.displayName +
      " - " +
      gateway.config.bankName +
      " - " +
      gateway.config.bankAccountNumber;

    ElNotification({
      title: "Gateway Selected",
      message: `${gateway.displayName} was added successfully.`,
      type: "success",
      duration: 3000,
    });
  } else {
    ElNotification({
      title: "Already Added",
      message: `${gateway.displayName} is already in the list.`,
      type: "warning",
      duration: 3000,
    });
  }
};

// confirm delete
const confirmDelete = (gateway) => {
  // ElMessageBox.confirm(
  //   `Are you sure you want to delete ${gateway.displayName} - ${gateway.bank} - ${gateway.accountNo}?`,
  //   "Confirm delete",
  //   {
  ElMessageBox.confirm(
    `Are you sure you want to delete ${gateway.displayName}?`,
    "Confirm delete",
    {
      confirmButtonText: "Yes, Delete",
      cancelButtonText: "Cancel",
      type: "error",
    }
  )
    .then(() => deleteGateway(gateway))
    .catch(() => {});
};

// delete from API
const deleteGateway = async (gateway) => {
  try {
    selectedGateways.value = selectedGateways.value.filter(
      (g) => g.id !== gateway.id
    );
    // await axios.delete(`/api/Payment/churchpaymentgateway/${gateway.id}`);
    // selectedGateways.value = selectedGateways.value.filter(
    //   (g) => g.id !== gateway.id
    // );
    ElNotification({
      title: "Success",
      message: "Gateway deleted successfully",
      type: "success",
    });
  } catch (err) {
    console.error(err);
    ElNotification({
      title: "Error",
      message: "Failed to delete gateway",
      type: "error",
    });
  }
};

const setSelectedBanks = () => {
  selectedBanks.value = gateways.value
    .filter((g) => g.selected)
    .map((g) => g.id);
};

const openContriModal = () => {
  displayContributionItem.value = true;
};
const newConItems = (payload) => {
  console.log(payload);
  contributionItems.value.push(payload);
  newContribution.value.payment[
    newContribution.value.payment.length - 1
  ].financialContribution = payload;

  // newContribution.value.payment[index].financialContribution = item;

  console.log(newContribution.value.payment, "newContribution.payment");
};

const removeTag = (id) => {
  const gateway = gateways.value.find((g) => g.id === id);
  if (gateway) gateway.selected = false;
  setSelectedBanks();
};

const toggleDisplayModal = (payload) => {
  displayResponsive.value = payload;
};
const closeContriDialog = (payload) => {
  if (payload) {
    displayContributionItem.value = false;
  }
};
const setSelectedBank = () => {
  selectedBank.value = nigerianBanks.value.find(
    (i) => i.id == selectedBankID.value
  );
  console.log(selectedBank.value, "selectedBank");
  bankSearchText.value = selectedBank.value.name;
};
const closeResponsive = () => {
  displayResponsive.value = false;
  router.push({ name: "ChartOfAccount" });
};
const addNewGateway = () => {
  showChurchPayment.value = true;
};

const closeSecondModal = () => {
  showChurchPayment.value = false;
  firstTemplate.value = true;
  selectedDefaultPayment.value = "";
  selectedGatewayConnect.value = "";
  selectedGatewayWithKey.value = "";
};

const closeThirdModal = () => {
  showConnectGateway.value = false;
  showChurchPayment.value = false;
  firstTemplate.value = true;
  selectedDefaultPayment.value = "";
  selectedGatewayConnect.value = "";
  selectedGatewayWithKey.value = "";
};

const continueToPayment = () => {
  ElNotification.success("Proceeding to payment...");
  showChurchPayment.value = false;
  firstTemplate.value = true;
};

const connectGateway = (gatewayName) => {
  // ElNotification.success(`Connecting to ${gatewayName}...`);
  showConnectGatewayDialog.value = true;
};

const showConfirmModal = (id, index) => {
  ElMessageBox.confirm("Are you sure you want to proceed?", "Confirm delete", {
    confirmButtonText: "OK",
    cancelButtonText: "Cancel",
    type: "error",
  })
    .then(() => {
      deleteContribution(id, index);
    })
    .catch(() => {
      ElNotification({
        type: "info",
        message: "Delete canceled",
      });
    });
};

const deleteContribution = (id, index) => {
  console.log(id);
  if (id) {
    axios
      .delete(
        `/mobile/v1/PaymentForm/contributionItem?contributionItemID=${id}`
      )
      .then((res) => {
        console.log(res);
        newContribution.value.payment.splice(index, 1);
        if (res.data) {
          ElNotification({
            type: "success",
            message: "Contribution item deleted",
            duration: 3000,
          });
        } else {
          ElNotification({
            type: "warning",
            message: "Delete Failed",
            duration: 3000,
          });
        }
      })
      .catch((err) => {
        finish();
        if (err.response) {
          ElNotification({
            type: "warning",
            message: err.response,
            duration: 3000,
          });
        } else if (err.toString().toLowerCase().includes("network error")) {
          ElNotification({
            type: "warning",
            message:
              "Network Error, Please Ensure you have a strong internet connection",
            duration: 3000,
          });
        } else if (err.toString().toLowerCase().includes("timeout")) {
          ElNotification({
            type: "warning",
            message:
              "Request Delayed,Make sure you have a strong internet connection",
            duration: 3000,
          });
        } else {
          ElNotification({
            type: "warning",
            message: "Delete Failed",
            duration: 3000,
          });
        }
        console.log(err);
      });
  } else {
    newContribution.value.payment.splice(index, 1);
    ElNotification({
      type: "success",
      message: "Contribution item deleted",
      duration: 3000,
    });
  }
};

// Fetch contribution items
const getContributionItems = async () => {
  try {
    const stored = store.getters["contributions/contributionItems"];
    if (stored && stored.length > 0) {
      contributionItems.value = stored;
    } else {
      const { data } = await axios.get("/api/financials/contributions/items");
      contributionItems.value = data;
    }
  } catch (error) {
    console.error("Error fetching contribution items:", error);
    contributionItems.value = [
      { id: 1, name: "Tithe" },
      { id: 2, name: "Offering" },
      { id: 3, name: "Building Fund" },
    ];
  }
};

const addContribution = () => {
  contributionSelections.value.push({
    selectedItem: "",
    id: Date.now(),
  });
  newContribution.value.payment.push({ financialContribution: {} });
};

// Update the selectContribution function
const selectContribution = (item, index) => {
  if (!contributionSelections.value[index]) {
    contributionSelections.value[index] = { selectedItem: "", id: Date.now() };
  }
  contributionSelections.value[index].selectedItem = item;

  if (!newContribution.value.payment[index]) {
    newContribution.value.payment[index] = { financialContribution: {} };
  }
  newContribution.value.payment[index].financialContribution = item;
};

// const getBanks = async () => {
//   try {
//     const res = await axios.get("/api/Financials/GetBanks");
//     nigerianBanks.value = res.data;
//   } catch (error) {
//     console.error("Error fetching banks:", error);
//     nigerianBanks.value = [
//       { code: "044", name: "Access Bank" },
//       { code: "014", name: "Afribank" },
//       { code: "023", name: "Citibank" },
//     ];
//   }
// };
const getBanks = () => {
  axios
    .get("/api/Financials/GetBanks")
    .then((res) => {
      console.log(res);
      nigerianBanks.value = res.data;
      getEditPayment();
    })
    .catch((err) => {
      console.log(err);
    });
};
// getBanks();

const filteredBanks = computed(() => nigerianBanks.value);

const resolveCustomerDetail = async () => {
  loading.value = true;
  if (!accountNumber.value || !selectedBank.value) return;

  try {
    const res = await axio.post(
      "https://api.ravepay.co/flwv3-pug/getpaidx/api/resolve_account",
      {
        recipientaccount: accountNumber.value,
        destbankcode: selectedBank.value.code,
        PBFPubKey: process.env.VUE_APP_FLUTTERWAVE_PUBLIC_KEY_LIVE,
      }
    );
    accountName.value = res.data.data.data.accountname;
    loading.value = false;
  } catch (error) {
    finish();
    console.log(error);

    loading.value = false;
    if (!accountNumber.value || accountNumber.value === "") {
      ElNotification({
        type: "warning",
        message: "Please enter your account number",
        duration: 3000,
      });
    } else if (!accountName.value || accountName.value === "") {
      ElNotification({
        type: "error",
        message: "Your detail were not found",
        duration: 3000,
      });
    } else {
      ElNotification({
        type: "error",
        message: "Please check your banks details again",
        duration: 3000,
      });
    }
  }
};
const saveAndContinue = async () => {
  if (!newContribution.value.name) {
    ElNotification.error("Please enter donation name");
    return;
  }

  if (!selectedGateways.value || selectedGateways.value.length === 0) {
    gatewayNotification.value = true;
    disabled.value = true;
    return;
  }

  gatewayNotification.value = false;
  disabled.value = false;

  let removeEmptyObj = newContribution.value.payment.filter((i) => {
    return Object.keys(i.financialContribution).length > 0;
  });
  let paymentForm = {
    name: newContribution.value.name,
    bankCode: selectedBank.value.code,
    accountName: accountName.value,
    accountNumber: accountNumber.value,
    isActive: isActive.value,
    contributionItems: removeEmptyObj.map((i) => {
      return { financialContributionID: i.financialContribution.id };
    }),
    tenantPaymentGatewayOptions: selectedGateways.value.map((gw, idx) => {
      return {
        churchPaymentGatewayID: gw.id,
        entityUsingPaymentGateWay: 0,
        priority: idx,
        isEnabled: 1,
      };
    }),
  };
  // paymentGateWays: selectedGateways.value.map((i) => {
  //   return {
  //     paymentGateWayID: i.paymentGatewayID,
  //     subAccountID: i.config.subAccountId,
  //     updateId: i.updateId,
  //   };
  // }),

  emit("form-details", paymentForm);

  try {
    loadingSave.value = true;

    // 🔹 CREATE flow
    if (!route.params.editNewPayment) {
      const res = await axios.post(
        "/api/PaymentForm/newpaymentform",
        paymentForm
      );
      const entityID = res.data.id;

      // const gatewayCalls = selectedGateways.value.map((gw, idx) => {
      //   const payload = {
      //     entityID,
      //     churchPaymentGatewayID: gw.id,
      //     entityUsingPaymentGateWay: 0,
      //     priority: idx,
      //     isEnabled: 1,
      //   };
      //   return axios.post(
      //     "/api/Payment/ChurchPaymentGateway/PaymentGatewayOptions",
      //     payload
      //   );
      // });

      // await Promise.all(gatewayCalls);

      // Navigation
      if (route.fullPath === "/tenant/donation") {
        store.dispatch("payment/getPayments").then(() => {
          router.push({
            name: "PaymentOption",
            params: { paymentId: entityID },
          });
        });
      } else if (route.fullPath === "/donationsetup") {
        store.dispatch("payment/getPayments").then(() => {
          router.push({ name: "OnboardingSuccessful" });
        });
      }

      finish();
    }
    // 🔹 UPDATE flow
    else {
      (paymentForm.contributionItems = newContribution.value.payment.map(
        (i) => {
          return { financialContributionID: i.financialContribution.id };
        }
      )),
        (paymentForm.id = route.params.editNewPayment);
      paymentForm.removeContributionIDs = removeContributionIDs.value;
      paymentForm.removePaymentGatewayIDs = removePaymentGatewayIDs.value;

      const res = await axios.put(`/api/PaymentForm/update`, paymentForm);
      const entityID = res.data.id;
      console.log(res.data, "hjkjh");

      // Update / re-add PaymentGatewayOptions
      // const gatewayCalls = selectedGateways.value.map((gw, idx) => {
      //   const payload = {
      //     entityID,
      //     churchPaymentGatewayID: gw.id,
      //     entityUsingPaymentGateWay: 0,
      //     priority: idx,
      //     isEnabled: 1,
      //   };
      //   return axios.post(
      //     "/api/Payment/ChurchPaymentGateway/PaymentGatewayOptions",
      //     payload
      //   );
      // });

      // await Promise.all(gatewayCalls);

      store.dispatch("contributions/paymentData", res.data);
      router.push({
        name: "PaymentOption",
        params: { paymentId: entityID || route.params.editNewPayment },
      });
      finish();
    }

    loadingSave.value = false;
  } catch (err) {
    console.error(err);
    loadingSave.value = false;
    finish();
  }
};
const getEditPayment = async () => {
  loadingEdit.value = true;
  if (route.params.editNewPayment) {
    try {
      const res = await axios.get(
        `/api/PaymentForm/GetOne?paymentFormID=${route.params.editNewPayment}`
      );
      console.log(res);
      loadingEdit.value = false;
      newContribution.value.name = res.data.name;
      ContributionItems.value = res.data.contributionItems;
      newContribution.value.payment = res.data.contributionItems.map((i) => i);
      accountNumber.value = res.data.accountNumber;
      accountName.value = res.data.accountName;
      // (bankSearchText.value = nigerianBanks.value.find(
      //   (i) => i.code == res.data.bankCode
      // ).name),
      isActive.value = res.data.isActive;
      selectedGateways.value = res.data.tenantPaymentGatewayOptions.map(
        (item) => {
          const gateway = item.churchPaymentGateway?.gateway || {};
          const config = item.churchPaymentGateway?.config
            ? item.churchPaymentGateway.config
            : {};

          return {
            displayName: item.churchPaymentGateway?.displayName || "",
            id: item.churchPaymentGateway?.id,
            config,
            imageUrl: gateway.imageUrl || "",
            isEnabled: item.isEnabled,
            priority: item.priority,
          };
        }
      );

      console.log(selectedGateways.value, "selectedGateways");

      // paymentGateWays.value = res.data.paymentGateWays.map((i) => {
      //   return {
      //     name: i.paymentGateway.name,
      //     countryCoverageArea: i.paymentGateway.countryCoverageArea,
      //     id: i.paymentGateway.id,
      //     isActive: i.paymentGateway.isActive,
      //     isSubAccountSupported: i.paymentGateway.isSubAccountSupported,
      //     subAccountID: i.subAccountID,
      //     updateId: i.updateId,
      //   };
      // });
      console.log(newContribution.value.payment);

      disabled.value = false;
    } catch (err) {
      console.log(err);
      finish();
      ElNotification({
        type: "error",
        message:
          "Network Error, Please ensure you have a strong internet connection",
        duration: 3000,
      });
      loadingEdit.value = true;
    }
  } else {
    isActive.value = true;
  }
};

const routeToIntegrations = () => {
  router.push("/tenant/settings/integrations");
};

// Initialize data
onMounted(() => {
  getContributionItems();
  getBanks();
});
</script>

<style scoped>
.border-bottom {
  border-bottom: 1px solid #ddd;
}
.menu-height {
  max-height: 250px;
  overflow-y: auto;
}
.form-container {
  background: white;
  border-radius: 8px;
  padding: 20px;
}

.form-title {
  font-size: 24px;
  font-weight: 600;
  color: #333;
  margin: 0 0 8px 0;
}

.go-back-link {
  color: #666;
  text-decoration: none;
  font-size: 14px;
}

.go-back-link:hover {
  color: #409eff;
}

.active-toggle {
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: flex-end;
}

.active-label {
  font-size: 14px;
  color: #666;
}

.form-group {
  margin-bottom: 30px;
}

.form-label {
  display: block;
  font-size: 16px;
  font-weight: 500;
  color: #333;
  margin-bottom: 8px;
}

.delete-btn {
  padding: 8px 12px;
}

.add-btn {
  background: #409eff;
  border: none;
  border-radius: 20px;
  padding: 8px 20px;
  font-size: 14px;
}

.payment-option {
  background: #d9ebef;
  border-radius: 11px;
  padding: 18px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.payment-option:hover {
  background: #d6ebfa;
}

.payment-option.active {
  background: #d9ebef;
}

/* Modal Styles */
:deep(.el-dialog) {
  border-radius: 12px;
}

:deep(.el-dialog__header) {
  padding: 20px 20px 0;
  border-bottom: 1px solid #f0f0f0;
}

:deep(.el-dialog__title) {
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

:deep(.el-dialog__body) {
  padding: 20px;
}

:deep(.el-dialog__footer) {
  padding: 0 20px 20px;
}

.connected-gateway-select {
  background: #f5f5f5;
}

.account-name-input :deep(.el-input__inner) {
  background: #e8f4fd !important;
}

.helper-text {
  color: #666;
  font-size: 12px;
  font-style: italic;
  margin-top: 5px;
  display: block;
}

.gateway-checkbox {
  width: 100%;
}

.gateway-info {
  display: flex;
  align-items: center;
  /* gap: 10px; */
}

.gateway-logo {
  width: 30px;
  height: 30px;
  object-fit: contain;
}

.gateway-name {
  font-size: 14px;
  font-weight: 500;
}

/* Connect Gateway Modal */
.connect-section {
  margin-top: 30px;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 20px;
}

.gateway-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.gateway-connect-item {
  padding: 5px 0;
  border-bottom: 1px solid #f0f0f0;
}

.gateway-connect-item:last-child {
  border-bottom: none;
}

.gateway-icon {
  width: 50px;
  height: 15px;
  object-fit: contain;
  margin-right: 15px;
}

.gateway-name-large {
  font-size: 16px;
  font-weight: 500;
}

.connect-btn {
  color: #000000;
  font-weight: 500;
  text-decoration: underline;
  padding: 0;
}

.connect-btn:hover {
  color: #111111;
}

.dialog-footer {
  text-align: center;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .form-container {
    padding: 15px;
  }

  .active-toggle {
    justify-content: flex-start;
    margin-top: 15px;
  }

  .text-right {
    text-align: left !important;
  }
}

@media (max-width: 576px) {
  .form-title {
    font-size: 20px;
  }
}
</style>
